import { render, staticRenderFns } from "./add-phone-config-model.vue?vue&type=template&id=7b5420e2"
import script from "./add-phone-config-model.vue?vue&type=script&lang=ts"
export * from "./add-phone-config-model.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports